import React from 'react'

import preloaderImage from './i/preloader.gif'

import styles from './Preloader.module.scss'

const Preloader = () => (
    <div className={styles.preloader}>
        <img src={preloaderImage} alt="loader" />
    </div>
)

export default Preloader
